import React from "react";
import {Row,Col} from "react-bootstrap"
import { useSelector} from "react-redux"
import dayjs from "dayjs";

const KonkursInfo  = (props) => {

    const konkursy = useSelector((magazyn) => magazyn.konkursy)
    const id       = useSelector((magazyn) => magazyn.opcje)
    
    const wyborKonkurs = (konkurs) => {
        return konkurs.id_konkursu === id.id_konkursu
    }

    const konkursWyb = konkursy.filter(wyborKonkurs)

    return  (
        <Row className= "uczestnik">
            <Row>
                <Col xs={3}><h3>Nr Ogłoszenia</h3></Col>
                <Col xs={2}><h3>Jednostka</h3></Col>
                <Col xs={3}><h3>Stanowisko</h3></Col>
                <Col xs={4}><h3>Z dnia</h3></Col>
            </Row> 
            { konkursWyb.map(konkurs => 
            <Row key={konkurs.id_konkursu}>
                <Col xs={3}><span className="wyroznienie">{konkurs.nr_ogloszenia}</span></Col>
                <Col xs={2}><span className="wyroznienie">{konkurs.jednostka}</span></Col>
                <Col xs={3}><span className="wyroznienie">{konkurs.nazwa_stanowiska}</span></Col>
                <Col xs={4}><span className="wyroznienie">{dayjs(konkurs.data_konkurs*1000).format('YYYY-MM-DD')}</span></Col>
            </Row> 
            )
        }
        </Row>
    )       
}
 
export default KonkursInfo